import Router from 'vue-router'
import Vue from 'vue'
import groupRoutes from './group.js'
import deliveryRoutes from './delivery.js'
import shipAgencyRoutes from './shipagency.js'
import martRoutes from './mart.js'
import resvRoutes from './reservation.js'
import bookingRoutes from './booking.js'
import pickupRoutes from './pickup.js'

function load(component) {
  // '@' is aliased to src/components
  return () => import(`@/components/${component}.vue`)
}

function loadPage(component, path = '') {
  // '@' is aliased to src/module
  let importPath = (path) ? path + '/' : '';
  return () => import(`@/components/page/` + importPath + `${component}.vue`)
}

Vue.use(Router)

const routes = {
  // 어드민
  'admin': [
    {path: 'videotest', component: loadPage('VideoTest', 'test')},
    {path: 'survey', component: loadPage('SurveyTest', 'test')},
    {path: 'test', component: loadPage('Test', 'test')},
    {path: 'dashboard', component: loadPage('Dashboards', 'dashboard')},
    {path: 'search_result', component: loadPage('SearchResult', 'search')},

    // 서비스 관리
    {path: 'service/info', component: loadPage('InfoSetting', 'service')},
    {path: 'service/utilize', component: loadPage('ServiceUtilize', 'service')},
    {path: 'service/plan', component: loadPage('Plan', 'service')},
    {path: 'service/plan_change', component: loadPage('PlanChange', 'service')},
    {path: 'service/info_detail', component: loadPage('ServiceInfoDetail', 'service')},
    {path: 'service/bill/payment', component: loadPage('MyPaymentList', 'service')},
    {path: 'service/setting', component: loadPage('ServiceSetting', 'service')},
    {path: 'service/account', component: loadPage('APISetting', 'service')},
    {path: 'service/policy', component: loadPage('Policy', 'service')},
    {path: 'service/plugin', component: loadPage('PluginSetting', 'service')},
    {path: 'service/product', component: loadPage('ProductSetting', 'service')},
    {path: 'service/adminmenu', component: loadPage('MenuSetting', 'service')},
    {path: 'service/partnermenu', component: loadPage('MenuSetting', 'service')},
    {path: 'service/kakao_message_template', component: loadPage('KakaoMessageTemplateSetting', 'service')},
    {path: 'account', component: loadPage('AdminList', 'service')},
    {path: 'service/seo', component: loadPage('SeoSetting', 'service')},

    // 메뉴
    { path: 'menu', component: loadPage('MenuModify', 'menu') },
    //{path: 'menu', component: loadPage('MenuReg', 'menu')},

    // 유저
    { path: 'user', component: loadPage('UserList', 'user')},
    { path: 'user/create', component: loadPage('UserRegBase', 'user')},
    { path: 'user/grade', component: loadPage('UserGradeList', 'user')},
    { path: 'user/grade/create', component: loadPage('UserGradeReg', 'user')},
    { path: 'user/grade/approval/new', component: loadPage('UserGradeApprovalNew', 'user')},
    { path: 'user/grade/approval/all', component: loadPage('UserGradeApprovalAll', 'user')},

    // 파트너
    { path: 'partner', component: loadPage('PartnerList', 'partner')},
    { path: 'partner/create', component: loadPage('PartnerCreate', 'partner')},
    { path: 'partner/grade', component: loadPage('PartnerGradeList', 'partner')},
    { path: 'partner/grade/create', component: loadPage('PartnerGradeReg', 'partner')},
    { path: 'partner/grade/approval/new', component: loadPage('PartnerGradeApprovalNew', 'partner')},
    { path: 'partner/grade/approval/all', component: loadPage('PartnerGradeApprovalAll', 'partner')},
    { path: 'partner/menu/setting', component: loadPage('PartnerMenuSetting', 'partner')},
    { path: 'partner/inquiry/new', component: loadPage('PartnerCreateInquiryNew', 'partner')},
    { path: 'partner/inquiry/all', component: loadPage('PartnerCreateInquiryAll', 'partner')},
    { path: 'partner/inquiry/create', component: loadPage('PartnerCreateInquiryReg', 'partner')},
    { path: 'partner/inquiry/category', component: loadPage('PartnerInquiryCategoryReg', 'partner') },
    { path: 'partner/approval/new', component: loadPage('PartnerApprovalNew', 'partner')},
    { path: 'partner/approval/all', component: loadPage('PartnerApprovalAll', 'partner')},
    { path: 'partner/setting', component: loadPage('PartnerSetting', 'partner') },

    // 슈퍼파트너
    { path: 'superpartner', component: loadPage('SuperPartnerList', 'partner')},
    { path: 'superpartner/create', component: loadPage('SuperPartnerReg', 'partner')},

    // 슈퍼파트너
    { path: 'supervisor', component: loadPage('SuperVisorList', 'supervisor')},
    { path: 'supervisor/create', component: loadPage('SuperVisorCreate', 'supervisor')},

    // 상품
    { path: 'product/create', component: loadPage('ProductReg', 'product') },
    { path: 'product', component: loadPage('ProductList', 'product') },
    { path: 'product/param/form', component: loadPage('ProductParamForm', 'product') },
    { path: 'product/option', component: loadPage('ProductOption', 'product') },

    { path: 'product/approval/new', component: loadPage('ProductApprovalNew', 'product') },
    { path: 'product/approval/all', component: loadPage('ProductApprovalAll', 'product') },

    // 상품 문의
    { path: 'product/inquiry/new', component: loadPage('ProductInquiryNew', 'product') },
    { path: 'product/inquiry/all', component: loadPage('ProductInquiryAll', 'product') },
    { path: 'product/inquiry/create', component: loadPage('ProductInquiryReg', 'product') },

    // 상품 후기
    { path: 'product/review/new', component: loadPage('ProductReviewList', 'product') },
    { path: 'product/review/all', component: loadPage('ProductReviewList', 'product') },
    { path: 'product/review/create', component: loadPage('ProductReviewReg', 'product') },

    // 상품 파라미터 (맞춤 db)
    { path: 'product/param', component: loadPage('ProductParamList', 'product') },
    { path: 'product/param/create', component: loadPage('ProductParamCreate', 'product') },

    // 상품 판넬
    { path: 'product/panel/setting', component: loadPage('ProductPanelSetting', 'product')},

    // 세부 별점 항목 관리
    { path: 'product/evaluation', component: loadPage('ProductEvaluationSetting', 'product') },

    // 파트너 파라미터 (맞춤 db)
    { path: 'partner/param', component: loadPage('PartnerParamList', 'partner') },
    { path: 'partner/param/form', component: loadPage('PartnerParamForm', 'partner') },
    { path: 'partner/param/create', component: loadPage('PartnerParamCreate', 'partner') },

    // 유저 파라미터 (맞춤 db)
    { path: 'user/param', component: loadPage('UserParamList', 'user') },
    { path: 'user/param/form', component: loadPage('UserParamForm', 'user') },
    { path: 'user/param/create', component: loadPage('UserParamCreate', 'user') },

    // 게시물 파라미터 (맞춤 db)
    { path: 'post/param', component: loadPage('PostParamList', 'post') },
    { path: 'post/param/create', component: loadPage('PostParamCreate', 'post') },

    // 카테고리
    { path: 'category/create', component: loadPage('CategoryReg', 'category') },
    { path: 'memo_category', component: loadPage('MemoCategory', 'category') },

    // 게시물
    { path: 'board/:id/post', component: loadPage('PostList', 'post') },
    { path: 'board/:id/post/create', component: loadPage('PostReg', 'post') },
    { path: 'board/:id/mapping', component: loadPage('PostMappingList', 'post') },
    { path: 'board/:id/mapping/create', component: loadPage('PostMappingCreate', 'post') },

    // 게시판
    { path: 'board', component: loadPage('BoardList', 'board') },
    { path: 'board/create', component: loadPage('BoardReg', 'board') },
    { path: 'board/category/create', component: loadPage('BoardCategoryReg', 'board') },

    // 공지사항
    { path: 'notice', component: loadPage('NoticeList', 'notice') },
    { path: 'notice/create', component: loadPage('NoticeReg', 'notice') },

    // faq
    { path: 'faq', component: loadPage('FaqList', 'faq') },
    { path: 'faq/create', component: loadPage('FaqReg', 'faq') },
    { path: 'faq/category', component: loadPage('FaqCategory', 'faq') },

    // 이벤트
    { path: 'event', component: loadPage('EventList', 'event') },
    { path: 'event/create', component: loadPage('EventReg', 'event') },

    // 쿠폰
    {path: 'coupon', component: loadPage('CouponList', 'coupon')},
    {path: 'coupon/create', component: loadPage('CouponCreate', 'coupon')},
    {path: 'coupon/user/create', component: loadPage('UserCouponCreate', 'coupon')},
    {path: 'coupon/user', component: loadPage('UserCouponList', 'coupon')},

    // 포인트
    { path: 'point/setting', component: loadPage('PointSetting', 'point') },

    // 배송비 조건
    {path: 'deliveryprice', component: loadPage('DeliveryPriceList', 'product')},
    {path: 'deliveryprice/create', component: loadPage('DeliveryPriceCreate', 'product')},

    // 입찰 관리
    { path: 'request/new', component: loadPage('RequestNew', 'estimate/request') },
    { path: 'request/all', component: loadPage('RequestAll', 'estimate/request') },
    { path: 'request/partner', component: loadPage('RequestPartner', 'estimate/request') },               // 파트너 의뢰

    // 견적서 관리
    { path: 'response/new', component: loadPage('ResponseNew', 'estimate/response') },
    { path: 'response/all', component: loadPage('ResponseAll', 'estimate/response') },

    // 주문 관리
    { path: 'order/new', component: loadPage('OrderNew', 'estimate/order') },                       // 신규 주문 신청 내역
    { path: 'order/all', component: loadPage('OrderAll', 'estimate/order') },                       // 주문 확정 내역

    // 견적 템플릿
    { path: 'estimate/template', component: loadPage('EstimateTemplate', 'estimate') },

    // 상품 옵션 견적 (요청, 견적서) 관리
    { path: 'option/resall', component: loadPage('OrderOptAll', 'estimate/option') },           // 전체 주문확정 내역
    //{ path: 'option/delivery', component: loadPage('OrderOptDelivery', 'estimate/option') },      // 배송대기 내역
    { path: 'option/resnew', component: loadPage('OrderOptNew', 'estimate/option') },           // 신규 주문신청 내역
    { path: 'option/reqall', component: loadPage('ReqOptAll', 'estimate/option') },               // 전체 상품옵션 견적요청 내역
    { path: 'option/reqnew', component: loadPage('ReqOptNew', 'estimate/option') },               // 신규 상품옵션 견적요청 내역
    { path: 'option/optsheetsubmit', component: loadPage('OptSheetSubmit', 'estimate/option') },               // 상품옵션 견적서 작성

    // 견적 요청서 관리
    { path: 'form', component: loadPage('Form', 'estimate/form') },
    { path: 'form/create', component: loadPage('FormReg', 'estimate/form') },
    { path: 'form/category', component: loadPage('FormCategory', 'estimate/form') },

    // 지역 관리
    { path: 'region', component: loadPage('RegionList', 'region') },
    { path: 'region/create', component: loadPage('RegionReg', 'region') },

    // 1:1 문의
    { path: 'cs/inquiry/new', component: loadPage('OnetoOneNew', 'one-to-one') },
    { path: 'cs/inquiry/all', component: loadPage('OnetoOneAll', 'one-to-one') },
    { path: 'cs/inquiry/create', component: loadPage('OnetoOneReg', 'one-to-one') },
    { path: 'cs/inquiry/category', component: loadPage('OnetoOneCategory', 'one-to-one') },
    { path: 'cs/inquiry/form', component: loadPage('OnetoOneForm', 'one-to-one') },

    // 전화 문의
    { path: 'cs/call/new', component: loadPage('CallNew', 'call') },  // 신규 전화 연결 내역
    { path: 'cs/call/all', component: loadPage('CallAll', 'call') },  // 전체 전화 연결 내역
    { path: 'cs/call/order/new', component: loadPage('CallOrderNew', 'call') },  // 오늘 전화상담/주문내역
    { path: 'cs/call/order/all', component: loadPage('CallOrderAll', 'call') },  // 전체 전화상담/주문내역
    { path: 'cs/call/create', component: loadPage('CallReg', 'call') },

    /* 공간 */
    { path: 'space/category/create', component: loadPage('CategoryReg', 'space') },
    { path: 'space/partner', component: loadPage('PartnerList', 'space')},
    { path: 'space/partner/create', component: loadPage('PartnerCreate', 'space')},
    { path: 'space/partner/param', component: loadPage('PartnerParamList', 'space') },
    { path: 'space/partner/param/create', component: loadPage('PartnerParamCreate', 'space') },
    { path: 'space/product/create', component: loadPage('ProductReg', 'space') },
    { path: 'space/product', component: loadPage('ProductList', 'space') },
    { path: 'space/product/param', component: loadPage('ProductParamList', 'space') },
    { path: 'space/product/param/create', component: loadPage('ProductParamCreate', 'space') },
    // 상품 문의
    { path: 'space/product/inquiry/new', component: loadPage('ProductInquiryNew', 'space') },
    { path: 'space/product/inquiry/all', component: loadPage('ProductInquiryAll', 'space') },
    { path: 'space/product/inquiry/create', component: loadPage('ProductInquiryReg', 'space') },

    // 상품 후기
    { path: 'space/product/review/new', component: loadPage('ProductReviewList', 'space') },
    { path: 'space/product/review/all', component: loadPage('ProductReviewList', 'space') },
    { path: 'space/product/review/create', component: loadPage('ProductReviewReg', 'space') },

    { path: 'space/call/new', component: loadPage('CallNew', 'space') },  // 신규 전화 연결 내역
    { path: 'space/call/all', component: loadPage('CallAll', 'space') },  // 전체 전화 연결 내역
    { path: 'space/call/create', component: loadPage('CallReg', 'space') },

    { path: 'order', component: loadPage('Order', 'service') },

    /* 커머스 다운로드 */
    // 다운로드
    { path: 'commerce/download/new', component: loadPage('DownloadNew', 'commerce/download') },
    { path: 'commerce/download/all', component: loadPage('DownloadAll', 'commerce/download') },
    { path: 'commerce/download/list', component: loadPage('DownloadList', 'commerce/download') },
    { path: 'commerce/download/detail', component: loadPage('DownloadDetail', 'commerce/download') },

    /* 커머스 일반 배송 */
    // 주문
    { path: 'commerce/purchase/new', component: loadPage('PurchaseNew', 'commerce/delivery/purchase') },
    { path: 'commerce/purchase/all', component: loadPage('PurchaseAll', 'commerce/delivery/purchase') },
    { path: 'commerce/purchase/create', component: loadPage('PurchaseCreate', 'commerce/delivery/purchase') },

    // 주문 상세
    { path: 'commerce/purchase/detail', component: loadPage('PurchaseDetail', 'commerce/delivery/purchase') },

    // 상품 준비
    { path: 'commerce/product/ready/new', component: loadPage('ProductReadyNew', 'commerce/delivery/ready') },
    { path: 'commerce/product/ready/all', component: loadPage('ProductReadyAll', 'commerce/delivery/ready') },

    // 배달
    { path: 'commerce/delivery/new', component: loadPage('DeliveryNew', 'commerce/delivery/delivery') },
    { path: 'commerce/delivery/doing', component: loadPage('DeliveryDoing', 'commerce/delivery/delivery') },
    { path: 'commerce/delivery/all', component: loadPage('DeliveryAll', 'commerce/delivery/delivery') },

    // 주문 취소
    { path: 'commerce/purchase/cancel/new', component: loadPage('PurchaseCancelNew', 'commerce/delivery/purchase') },
    { path: 'commerce/purchase/cancel/all', component: loadPage('PurchaseCancelAll', 'commerce/delivery/purchase') },

    // 정산
    { path: 'commerce/account/new', component: loadPage('AccountNew', 'commerce/account') },
    { path: 'commerce/account/all', component: loadPage('AccountAll', 'commerce/account') },
    { path: 'commerce/account/setting', component: loadPage('AccountSetting', 'commerce/account') },

    { path: 'commerce/point/setting', component: loadPage('PointSetting', 'point') },

    // 무통장 입금 은행 관리
    { path: 'commerce/nopass', component: loadPage('NoPassList', 'commerce/nopass') },
    { path: 'commerce/nopass/create', component: loadPage('NoPassCreate', 'commerce/nopass') },

    // 커머스 설정
    { path: 'commerce/purchase/setting', component: loadPage('PurchaseSetting', 'commerce/setting/purchase') },

    // 아웃링크
    { path: 'outlink/new', component: loadPage('OutlinkNew', 'outlink') },
    { path: 'outlink/all', component: loadPage('OutlinkAll', 'outlink') },


    // 상담
    { path: 'counsel/form', component: loadPage('CounselForm', 'counsel') },
    { path: 'counsel/form/create', component: loadPage('CounselFormReg', 'counsel') },
    { path: 'counsel/request/new', component: loadPage('CounselRequestNew', 'counsel') },
    { path: 'counsel/request/all', component: loadPage('CounselRequestAll', 'counsel') },

    // 모임
    { path: 'meet/form', component: loadPage('MeetForm', 'meet') },
    { path: 'meet/form/create', component: loadPage('MeetFormReg', 'meet') },
    { path: 'meet/request/new', component: loadPage('MeetRequestNew', 'meet') },
    { path: 'meet/request/all', component: loadPage('MeetRequestAll', 'meet') },
    { path: 'meet/request/detail', component: loadPage('MeetRequestDetail', 'meet') },

    // 정산
    { path: 'meet/account/new', component: loadPage('AccountNew', 'meet') },
    { path: 'meet/account/all', component: loadPage('AccountAll', 'meet') },
    { path: 'meet/account/setting', component: loadPage('AccountSetting', 'meet') },


    // 기획전 관리
    { path: 'exhibition', component: loadPage('ExhibitionList', 'exhibition') },
    { path: 'exhibition/create', component: loadPage('ExhibitionReg', 'exhibition') },
    // 파트너 기획전 관리
    { path: 'exhibition_partner', component: loadPage('ExhibitionPartnerList', 'exhibition_partner') },
    { path: 'exhibition_partner/create', component: loadPage('ExhibitionPartnerReg', 'exhibition_partner') },

    // 파트너별 상품 기획전 관리
    { path: 'exhibition_partner_product', component: loadPage('ExhibitionPartnerProductList', 'exhibition_partner_product') },
    { path: 'exhibition_partner_product/create', component: loadPage('ExhibitionPartnerProductReg', 'exhibition_partner_product') },

    // 배너 관리
    { path: 'banner', component: loadPage('BannerList', 'banner') },
    { path: 'banner/create', component: loadPage('BannerReg', 'banner') },

    // 팝업 관리
    { path: 'popup', component: loadPage('PopupList', 'popup') },
    { path: 'popup/create', component: loadPage('PopupReg', 'popup') },

    // 서비스가이드 관리
    { path: 'guide', component: loadPage('GuideList', 'guide') },
    { path: 'guide/create', component: loadPage('GuideReg', 'guide') },

    // 푸시 관리
    { path: 'push/create', component: loadPage('PushReg', 'push') },
    { path: 'push', component: loadPage('PushList', 'push') },

    // 문자 관리
    { path: 'sms/create', component: loadPage('SmsCreate', 'sms')},
    { path: 'sms', component: loadPage('SmsList', 'sms')},

    // 이메일 관리
    { path: 'email/create', component: loadPage('EmailCreate', 'email')},
    { path: 'email', component: loadPage('EmailList', 'email')},

    { path: 'filter', component: loadPage('FilterSetting', 'filter') },

    // 메시지 템플릿
    { path: 'sms_message_template', component: loadPage('MessageTemplate', 'sms')},
    { path: 'sms_message_template/create', component: loadPage('MessageTemplateCreate', 'sms')},

    // 슈퍼어드민
    { path: 'launchpack/service', component: loadPage('ServiceList', 'launchpack/service')},
    { path: 'launchpack/service_version', component: loadPage('ServiceVersionList', 'launchpack/service')},
    { path: 'launchpack/office_version', component: loadPage('OfficeVersion', 'launchpack/service')},
    { path: 'launchpack/service/create', component: loadPage('ServiceReg', 'launchpack/service')},
    { path: 'launchpack/service/update', component: loadPage('ServiceUpdate', 'launchpack/service')},
    { path: 'launchpack/service/detail', component: loadPage('ServiceDetail', 'launchpack/service')},
    { path: 'launchpack/utilize/service', component: loadPage('ServiceUtilize', 'launchpack/service')},
    { path: 'launchpack/utilize/all', component: loadPage('ServiceUtilizeAll', 'launchpack/service')},

    { path: 'launchpack/qa', component: loadPage('QualityAssurance', 'launchpack/service')},
    { path: 'launchpack/qa_sheet', component: loadPage('QaSheet', 'launchpack/service')},
    { path: 'launchpack/qa_improve', component: loadPage('QaImprove', 'launchpack/service')},

    { path: 'launchpack/service/menu', component: loadPage('ServiceMenu', 'launchpack/service')},
    { path: 'launchpack/service/log', component: loadPage('ServiceLog', 'launchpack/service')},

    { path: 'launchpack/bill/payment', component: loadPage('PaymentList', 'launchpack/bill')},

    { path: 'launchpack/service/inquiry', component: loadPage('ServiceInquiry', 'launchpack/mail')},
    { path: 'launchpack/service/inquiry/detail', component: loadPage('ServiceInquiryDetail', 'launchpack/mail')},
    { path: 'launchpack/service/inquiry/create', component: loadPage('ServiceInquiryCreate', 'launchpack/mail')},
    { path: 'launchpack/theme/request', component: loadPage('ThemeRequest', 'launchpack/mail')},
    { path: 'launchpack/theme/request/detail', component: loadPage('ThemeRequestDetail', 'launchpack/mail')},

    { path: 'launchpack/notice', component: loadPage('NoticeList', 'launchpack/notice')},
    { path: 'launchpack/notice/create', component: loadPage('NoticeReg', 'launchpack/notice')},

    { path: 'launchpack/skin_inquiry', component: loadPage('SkinInquiry', 'launchpack/service')},
    { path: 'launchpack/skin_inquiry/detail', component: loadPage('SkinInquiryDetail', 'launchpack/service')},

    // 마스터 게시판
    /*{ path: 'master/notice', component: loadPage('NoticeList', 'master/notice')},
    { path: 'master/notice/detail', component: loadPage('NoticeDetail', 'master/notice')},*/

    { path: 'launchpack/inquiry/customer/category', component: loadPage('CustomerInquiryCategory', 'launchpack/customer')},
    { path: 'launchpack/inquiry/customer', component: loadPage('CustomerInquiry', 'launchpack/customer')},
    { path: 'launchpack/inquiry/customer/create', component: loadPage('CustomerInquiryReg', 'launchpack/customer')},

    { path: 'launchpack/inquiry/template', component: loadPage('TemplateInquiry', 'launchpack/builder')},
    { path: 'launchpack/inquiry/template/detail', component: loadPage('TemplateInquiryDetail', 'launchpack/builder')},
    { path: 'launchpack/survey', component: loadPage('Survey', 'launchpack/builder')},

    // 관리비
    { path: 'launchpack/management_fee_add', component: loadPage('ManagementFeeAdd', 'launchpack/management')},
    { path: 'launchpack/management_fee_subtract', component: loadPage('ManagementFeeSubtract', 'launchpack/management')},
    { path: 'launchpack/management_fee_subtract/detail', component: loadPage('ManagementFeeDetail', 'launchpack/management')},

    { path: 'launchpack/hosting', component: loadPage('HostingList', 'launchpack/management')},
    { path: 'launchpack/hosting/create', component: loadPage('HostingCreate', 'launchpack/management')},
    { path: 'launchpack/care_service', component: loadPage('CareServiceList', 'launchpack/management')},
    { path: 'launchpack/care_service/create', component: loadPage('CareServiceCreate', 'launchpack/management')},


    //플러그인
    { path: 'launchpack/internal_plugin', component: loadPage('InternalPluginList', 'launchpack/plugin')},
    { path: 'launchpack/internal_plugin/create', component: loadPage('InternalPluginCreate', 'launchpack/plugin')},
    { path: 'launchpack/sms_send_point', component: loadPage('SmsSendPointList', 'launchpack/sms')},
    { path: 'launchpack/sms_send_point/create', component: loadPage('SmsSendPointCreate', 'launchpack/sms')},

    { path: 'launchpack/service_plan/management', component: loadPage('ServicePlanManagementList', 'launchpack/service')},
    { path: 'launchpack/service_plan', component: loadPage('ServicePlanList', 'launchpack/service')},
    { path: 'launchpack/service_plan/create', component: loadPage('ServicePlanDetail', 'launchpack/service')},
    // 수동설치 내역 (deprecated. 2022-07-28)
    { path: 'launchpack/service_app_order_request', component: loadPage('ServiceAppOrderRequestList', 'launchpack/service')},

    // 템플릿 주문내역, 정산
    { path: 'launchpack/templates/inquiry', component: loadPage('SourceInquiryList', 'launchpack/templates') },
    { path: 'launchpack/templates/inquiry/detail', component: loadPage('SourceInquiryDetail', 'launchpack/templates') },
    { path: 'launchpack/templates/all', component: loadPage('TemplatesAll', 'launchpack/templates') },
    { path: 'launchpack/templates/account/new', component: loadPage('AccountNew', 'launchpack/templates') },
    { path: 'launchpack/templates/account/all', component: loadPage('AccountAll', 'launchpack/templates') },
    { path: 'launchpack/templates/account/setting', component: loadPage('AccountSetting', 'launchpack/templates') },


    { path: 'plugin/:id', component: loadPage('ExtPluginSetting', 'service')},
  ],
  // 파트너
  'partner': [
    {path: 'dashboard', component: loadPage('Dashboards', 'dashboard')},
    // 상품
    { path: 'product', component: loadPage('ProductList', 'product') },
    { path: 'product/create', component: loadPage('ProductReg', 'product') },

    { path: 'product/approval/new', component: loadPage('ProductApprovalNew', 'product') },
    { path: 'product/approval/all', component: loadPage('ProductApprovalAll', 'product') },

    // 파트너
    { path: 'partner/create', component: loadPage('PartnerCreate', 'partner')},

    // 견적
    { path: 'order', component: loadPage('ProductReg', 'product') },
    { path: 'product', component: loadPage('ProductList', 'product') },

    // 카테고리
    { path: 'category/create', component: loadPage('CategoryReg', 'category') },

    // 게시물
    { path: 'board/:id/post', component: loadPage('PostList', 'post') },
    { path: 'board/:id/post/create', component: loadPage('PostReg', 'post') },

    // 게시판
    { path: 'board', component: loadPage('BoardList', 'board') },
    { path: 'board/create', component: loadPage('BoardReg', 'board') },

    // 입찰 관리
    { path: 'request/new', component: loadPage('RequestNew', 'estimate/request') },
    { path: 'request/all', component: loadPage('RequestAll', 'estimate/request') },
    { path: 'request/partner', component: loadPage('RequestPartner', 'estimate/request') },               // 파트너 의뢰

    // 견적서 관리
    { path: 'response/new', component: loadPage('ResponseNew', 'estimate/response') },
    { path: 'response/all', component: loadPage('ResponseAll', 'estimate/response') },

    // 주문 관리
    { path: 'order/new', component: loadPage('OrderNew', 'estimate/order') },                       // 신규 주문 신청 내역
    { path: 'order/all', component: loadPage('OrderAll', 'estimate/order') },                       // 주문 내역

    // 상품 옵션 견적 (주문, 요청) 관리
    { path: 'option/orderall', component: loadPage('OrderOptAll', 'estimate/option') },           // 전체 주문확정 내역
    //{ path: 'option/delivery', component: loadPage('OrderOptDelivery', 'estimate/option') },      // 배송대기 내역
    { path: 'option/ordernew', component: loadPage('OrderOptNew', 'estimate/option') },           // 신규 주문신청 내역
    { path: 'option/reqall', component: loadPage('ReqOptAll', 'estimate/option') },               // 전체 상품옵션 견적요청 내역
    { path: 'option/reqnew', component: loadPage('ReqOptNew', 'estimate/option') },               // 신규 상품옵션 견적요청 내역
    { path: 'option/optsheetsubmit', component: loadPage('OptSheetSubmit', 'estimate/option') },               // 상품옵션 견적서 작성

    // 견적 요청서 관리
    { path: 'form', component: loadPage('Form', 'estimate/form') },
    { path: 'form/create', component: loadPage('FormReg', 'estimate/form') },

    // 상품 문의
    { path: 'product/inquiry/new', component: loadPage('ProductInquiryNew', 'product') },
    { path: 'product/inquiry/all', component: loadPage('ProductInquiryAll', 'product') },
    { path: 'product/inquiry/create', component: loadPage('ProductInquiryReg', 'product') },

    // 상품 후기
    { path: 'product/review/new', component: loadPage('ProductReviewList', 'product') },
    { path: 'product/review/all', component: loadPage('ProductReviewList', 'product') },
    { path: 'product/review/create', component: loadPage('ProductReviewReg', 'product') },

    // 전화 문의
    { path: 'cs/call/new', component: loadPage('CallNew', 'call') },  // 신규 전화 연결 내역
    { path: 'cs/call/all', component: loadPage('CallAll', 'call') },  // 전체 전화 연결 내역
    { path: 'cs/call/order/new', component: loadPage('CallOrderNew', 'call') },  // 오늘 전화상담/주문내역
    { path: 'cs/call/order/all', component: loadPage('CallOrderAll', 'call') },  // 전체 전화상담/주문내역
    { path: 'cs/call/create', component: loadPage('CallReg', 'call') },


    /* 커머스 다운로드 */
    // 다운로드
    { path: 'commerce/download/new', component: loadPage('DownloadNew', 'commerce/download') },
    { path: 'commerce/download/all', component: loadPage('DownloadAll', 'commerce/download') },
    { path: 'commerce/download/detail', component: loadPage('DownloadDetail', 'commerce/download') },


    /* 커머스 일반 배송 */
    // 주문
    { path: 'commerce/purchase/new', component: loadPage('PurchaseNew', 'commerce/delivery/purchase') },
    { path: 'commerce/purchase/all', component: loadPage('PurchaseAll', 'commerce/delivery/purchase') },
    { path: 'commerce/purchase/create', component: loadPage('PurchaseCreate', 'commerce/delivery/purchase') },

    // 주문 상세
    { path: 'commerce/purchase/detail', component: loadPage('PurchaseDetail', 'commerce/delivery/purchase') },

    // 상품 준비
    { path: 'commerce/product/ready/new', component: loadPage('ProductReadyNew', 'commerce/delivery/ready') },
    { path: 'commerce/product/ready/all', component: loadPage('ProductReadyAll', 'commerce/delivery/ready') },

    // 배달
    { path: 'commerce/delivery/new', component: loadPage('DeliveryNew', 'commerce/delivery/delivery') },
    { path: 'commerce/delivery/doing', component: loadPage('DeliveryDoing', 'commerce/delivery/delivery') },
    { path: 'commerce/delivery/all', component: loadPage('DeliveryAll', 'commerce/delivery/delivery') },

    // 주문 취소
    { path: 'commerce/purchase/cancel/new', component: loadPage('PurchaseCancelNew', 'commerce/delivery/purchase') },
    { path: 'commerce/purchase/cancel/all', component: loadPage('PurchaseCancelAll', 'commerce/delivery/purchase') },

    // 정산
    { path: 'commerce/account/new', component: loadPage('AccountNew', 'commerce/account') },
    { path: 'commerce/account/all', component: loadPage('AccountAll', 'commerce/account') },

    // 아웃링크
    { path: 'outlink/new', component: loadPage('OutlinkNew', 'outlink') },
    { path: 'outlink/all', component: loadPage('OutlinkAll', 'outlink') },

    // 상담
    { path: 'counsel/form', component: loadPage('CounselForm', 'counsel') },
    { path: 'counsel/form/create', component: loadPage('CounselFormReg', 'counsel') },
    { path: 'counsel/request/new', component: loadPage('CounselRequestNew', 'counsel') },
    { path: 'counsel/request/all', component: loadPage('CounselRequestAll', 'counsel') },

    // 모임
    { path: 'meet/form', component: loadPage('MeetForm', 'meet') },
    { path: 'meet/form/create', component: loadPage('MeetFormReg', 'meet') },
    { path: 'meet/request/new', component: loadPage('MeetRequestNew', 'meet') },
    { path: 'meet/request/all', component: loadPage('MeetRequestAll', 'meet') },

    // 정산
    { path: 'meet/account/new', component: loadPage('AccountNew', 'meet') },
    { path: 'meet/account/all', component: loadPage('AccountAll', 'meet') },
    { path: 'meet/account/setting', component: loadPage('AccountSetting', 'meet') },

    // 쿠폰
    {path: 'coupon', component: loadPage('CouponList', 'coupon')},
    {path: 'platform_coupon', component: loadPage('CouponList', 'coupon')},
    {path: 'coupon/create', component: loadPage('CouponCreate', 'coupon')},
    {path: 'coupon/user/create', component: loadPage('UserCouponCreate', 'coupon')},
    {path: 'coupon/user', component: loadPage('UserCouponList', 'coupon')},

    // 배송비 조건
    {path: 'deliveryprice', component: loadPage('DeliveryPriceList', 'product')},
    {path: 'deliveryprice/create', component: loadPage('DeliveryPriceCreate', 'product')},

    // 템플릿 주문내역, 정산
    { path: 'launchpack/templates/all', component: loadPage('TemplatesAll', 'launchpack/templates') },
    { path: 'launchpack/templates/account/new', component: loadPage('AccountNew', 'launchpack/templates') },
    { path: 'launchpack/templates/account/all', component: loadPage('AccountAll', 'launchpack/templates') },
    { path: 'launchpack/templates/account/setting', component: loadPage('AccountSetting', 'launchpack/templates') },
  ],
  'space_partner': [
    {path: 'dashboard', component: loadPage('Dashboard', 'space')},
    { path: 'space/category/create', component: loadPage('CategoryReg', 'space') },
    { path: 'space/partner', component: loadPage('PartnerList', 'space')},
    { path: 'space/partner/create', component: loadPage('PartnerCreate', 'space')},
    { path: 'space/partner/param', component: loadPage('PartnerParamList', 'space') },
    { path: 'space/partner/param/create', component: loadPage('PartnerParamCreate', 'space') },
    { path: 'space/product/create', component: loadPage('ProductReg', 'space') },
    { path: 'space/product', component: loadPage('ProductList', 'space') },
    { path: 'space/product/param', component: loadPage('ProductParamList', 'space') },
    { path: 'space/product/param/create', component: loadPage('ProductParamCreate', 'space') },
    { path: 'space/product/inquiry/new', component: loadPage('ProductInquiryNew', 'space') },
    { path: 'space/product/inquiry/all', component: loadPage('ProductInquiryAll', 'space') },
    { path: 'space/product/inquiry/create', component: loadPage('ProductInquiryReg', 'space') },
    { path: 'space/product/review/new', component: loadPage('ProductReviewList', 'space') },
    { path: 'space/product/review/all', component: loadPage('ProductReviewList', 'space') },
    { path: 'space/product/review/create', component: loadPage('ProductReviewReg', 'space') },
    { path: 'space/call/new', component: loadPage('CallNew', 'space') },  // 신규 전화 연결 내역
    { path: 'space/call/all', component: loadPage('CallAll', 'space') },  // 전체 전화 연결 내역
    { path: 'space/call/create', component: loadPage('CallReg', 'space') },
  ],

  // 슈퍼파트너
  'superpartner': [],
  'supervisor': [
    { path: 'supervisor/create', component: loadPage('SuperVisorCreate', 'supervisor') },
    { path: 'dashboard', component: loadPage('SuperVisorDashBoard', 'dashboard')},
    // 상품
    { path: 'product/create', component: loadPage('ProductReg', 'product') },
    { path: 'product', component: loadPage('ProductList', 'product') },
  ]
}

// 그룹 라우팅 파일
groupRoutes['admin'].forEach(item=>{
  routes['admin'].push(item)
  routes['partner'].push(item)
  routes['superpartner'].push(item)
})

// 배송대행 라우팅
shipAgencyRoutes['admin'].forEach(item=>{
  routes['admin'].push(item)
})

// 배송 라우팅
deliveryRoutes['admin'].forEach(item=>{
  routes['admin'].push(item)
  routes['partner'].push(item)
})

martRoutes['admin'].forEach(item=> {
  routes['admin'].push(item)
  routes['partner'].push(item)
  routes['supervisor'].push(item)
})

// 예약 라우팅
resvRoutes['admin'].forEach(item=> {
  routes['admin'].push(item)
  routes['partner'].push(item)
})
// 숙박예약 라우팅
bookingRoutes['admin'].forEach(item=> {
  routes['admin'].push(item)
  routes['partner'].push(item)
})
// 숙박예약 라우팅
pickupRoutes['admin'].forEach(item=> {
  routes['admin'].push(item)
  routes['partner'].push(item)
})

const scrollBehavior = function(to, from, savedPosition) {
  if (to.hash && to.hash.indexOf('#item') === -1) {
    return savedPosition;
  }
  else if(savedPosition) {
    return savedPosition;
  }
  else {
    document.getElementsByTagName('body')[0].scrollTo(0,0);
    return { x: 0, y: 0 }
  }
}


const router = new Router({
  mode: 'history',
  routes: [
    { path: '/office/admin/login', component: loadPage('AdminLogin', 'login')},
    { path: '/office/partner/login', component: loadPage('PartnerLogin', 'login')},
    { path: '/office/space_partner/login', component: loadPage('SpacePartnerLogin', 'login')},
    { path: '/office/superpartner/login', component: loadPage('SuperPartnerLogin', 'login')},
    { path: '/office/supervisor/login', component: loadPage('SuperVisorLogin', 'login')},

    {path: '/office/admin/frbuilder', component: loadPage('FromBuilder', 'from_builder')},
    {
      path: '/office/admin', component: load('Index'),
      children: routes['admin']
    },
    {
      path: '/office/partner', component: load('Index'),
      children: routes['partner']
    },
    {
      path: '/office/space_partner', component: load('Index'),
      children: routes['space_partner']
    },
    {
      path: '/office/superpartner', component: load('Index'),
      children: routes['superpartner']
    },
    {
      path: '/office/supervisor', component: load('Index'),
      children: routes['supervisor']
    },
    // 팀
    {
      path: '/office/admin/group_admin/:group_id/', component: load('Index'),
      children: groupRoutes['base']
    },
    {
      path: '/office/superpartner/group_admin/:group_id/', component: load('Index'),
      children: groupRoutes['base']
    },
    {
      path: '/office/partner/group_admin/:group_id/', component: load('Index'),
      children: groupRoutes['base']
    },
    // 테마
    { path: '/office/admin/theme/:theme_key/login', component: loadPage('AdminLogin', 'login')},
    { path: '/office/partner/theme/:theme_key/login', component: loadPage('PartnerLogin', 'login')},
    {
      path: '/office/admin/theme/:theme_key', component: load('Index'),
      children: routes['admin']
    },
    {
      path: '/office/partner/theme/:theme_key', component: load('Index'),
      children: routes['partner']
    }
  ],
  scrollBehavior,
})

router.beforeEach((to, from, next) => {
  if (from.params.theme_key !== undefined &&
      to.params.theme_key === undefined) {
    let toPath;
    let toFullPath;
    if (to.path.indexOf('/admin') > -1) {
      toPath = to.path.replace('/office/admin', '/office/admin/theme/' + from.params.theme_key);
      toFullPath = to.fullPath.replace('/office/admin', '/office/admin/theme/' + from.params.theme_key);
    } else {
      toPath = to.path.replace('/office/partner', '/office/partner/theme/' + from.params.theme_key);
      toFullPath = to.fullPath.replace('/office/partner', '/office/partner/theme/' + from.params.theme_key);
    }
    next({
      fullPath: toFullPath,
      path: toPath,
      params: from.params
    });
    return;
  }
  if(from.meta.clickPush) {
    to.meta.isRefresh = true;
    from.meta.clickPush = false;
  } else {
    to.meta.isRefresh = false;
  }
  to.meta.toPath = to.path;
  to.meta.fromPath = from.path;
  from.meta.toPath = to.path;
  from.meta.fromPath = from.path;
  next();
})

// function setMeta(item) {
//   item.meta = {
//     isRefresh: false,
//     clickPush: false
//   }
//   if(item.children) {
//     item.children.forEach(child => {
//       setMeta(child);
//     })
//   }
// }
// router.options.routes.forEach(item => {
//   setMeta(item);
// })

export default router
